import { isEmpty } from "lodash";
import { IAppConfig } from "./LLMValidator";
import { getAIAAPIEndpoint } from "./helper";
import { AppRegion } from "../common/types/types";
import { TEXT_PROVIDER } from "../constant";
const localAppMetadata = require("../app_metadata_config.js");
const axios = require("axios").default;

export const fetchAppMetadata = async () => {
  try {
    const headers = {
      access_token: process.env.REACT_APP_STACK_DELIVERY_KEY,
      api_key: process.env.REACT_APP_STACK_API_KEY,
    };
    const params = {
      locale: process.env.REACT_APP_STACK_LOCALE,
      environment: process.env.REACT_APP_STACK_ENV,
    };
    const urlParams = {
      content_type_uid: process.env.REACT_APP_CT_UID,
      entry_uid: process.env.REACT_APP_ENTRY_UID,
    };
    return axios({
      method: "GET",
      url: `https://cdn.contentstack.io/v3/content_types/${urlParams.content_type_uid}/entries/${urlParams.entry_uid}`,
      headers: headers,
      params: params,
    })
      .then((res: any) => {
        return res.data.entry;
      })
      .catch((err: any) => {
        console.log("error here", err);
        return localAppMetadata.default;
      });
  } catch (error) {
    console.error("Error while fetching data", error);
    return localAppMetadata.default;
  }
};

interface IEncryptedAppConfig {
  model: {
    value: string
  };
  model_control?: any;
  keys: {
    data: string,
    iv: string,
  };
  masked_keys: string
}

export function validateIfNeedsEncryption(config: IAppConfig): boolean {
  return !isEmpty(config.api_key) || !isEmpty(config.api_version) || !isEmpty(config.access_key) || !isEmpty(config.secret_access_key) || !isEmpty(config.aws_region);
}

export const getKeys = (config: IAppConfig, provider: TEXT_PROVIDER) => ({
  api_key: config.api_key,
  azure_api_version: config.api_version,
  access_key: provider === TEXT_PROVIDER.VERTEX_AI ? config.access_key : undefined,
  aws_access_key: provider === TEXT_PROVIDER.AWS_BEDROCK ? config.access_key : undefined,
  aws_secret_access_key: config.secret_access_key,
  aws_region: config.aws_region,
  aws_llm: config.aws_llm,
  azure_deployment_id: config.deployment_id,
  azure_resource_name: config.resource_name,
});

// the encrypted object has different fields is because of the way generator-service expects it.
// we can't update the field name either since existing data will be ignored/lost until migration. 
export const encryptAppConfig = async (region: AppRegion, token: string, config: IAppConfig, provider: TEXT_PROVIDER): Promise<IEncryptedAppConfig> => {
  const response = await axios.post(`${getAIAAPIEndpoint(region)}/v1/encryptLLMKeys`, {
    keys: getKeys(config, provider),
    provider: provider
  }, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    }
  });
  return {
    model: config.model,
    model_control: config["model_control"],
    keys: response.data.keys,
    masked_keys: response.data.masked_keys
  }
};

export const decryptAppConfig = async (region: AppRegion, token: string, config: any, provider: TEXT_PROVIDER): Promise<IAppConfig> => {
  if (config?.masked_keys) {
    return {
      deployment_id: config?.masked_keys.azure_deployment_id,
      resource_name: config?.masked_keys.azure_resource_name,
      api_key: config?.masked_keys.api_key,
      model: config.model,
      model_control: config["model_control"],
      api_version: config?.masked_keys.azure_api_version,
      access_key: provider === TEXT_PROVIDER.AWS_BEDROCK ? config?.masked_keys.aws_access_key : config?.masked_keys.access_key,
      secret_access_key: config?.masked_keys.aws_secret_access_key,
      aws_region: config?.masked_keys.aws_region,
      aws_llm: config?.masked_keys.aws_llm,

    };
  }
  else if (config.keys?.data && config.keys?.iv) {
    const response = await axios.post(`${getAIAAPIEndpoint(region)}/v1/decryptLLMKeys`, {
      ...config.keys,
      provider: provider
    }, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }
    });
    const decrypted = response.data;
    return {
      deployment_id: decrypted.azure_deployment_id,
      resource_name: decrypted.azure_resource_name,
      model: config.model,
      model_control: config["model_control"],
      api_key: decrypted.api_key,
      api_version: decrypted.azure_api_version,
      access_key: provider === TEXT_PROVIDER.AWS_BEDROCK ? decrypted.aws_access_key : decrypted.access_key,
      secret_access_key: decrypted.aws_secret_access_key,
      aws_region: decrypted.aws_region,
      aws_llm: decrypted.aws_llm,
    }
  }
  return config;
};

